import React from 'react';

import IcErrorFilled from '@deliveryhero/pd-cookbook/components/Icons/IcErrorFilled';
import IcInfoFilled from '@deliveryhero/pd-cookbook/components/Icons/IcInfoFilled';
import IcSuccessFilled from '@deliveryhero/pd-cookbook/components/Icons/IcSuccessFilled';
import { Alert, Box } from '@mui/material';

import { SnackbarContent, VariantType } from 'notistack';

import '@deliveryhero/pd-cookbook/assets/scss/helpers/_utility-classes.scss';

interface SnackbarProps {
  id: string;
  message: string;
  variant: Exclude<VariantType, 'default' | 'warning'>;
  onClick?: () => void;
}

const Snackbar = (
  props: SnackbarProps,
  ref: React.ForwardedRef<HTMLDivElement>
) => {
  const { id, message, variant, onClick, ...other } = props;

  const Icon =
    variant === 'success'
      ? IcSuccessFilled
      : variant === 'error'
      ? IcErrorFilled
      : IcInfoFilled;
  const backgroundColor =
    variant === 'success'
      ? 'system.success'
      : variant === 'error'
      ? 'system.error'
      : 'system.information';

  const handleRetryClick = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();
    onClick && onClick();
  };

  const retry = (
    <Box
      sx={{
        fontWeight: 600,
        fontSize: 14,
        lineHeight: '21px',
        marginRight: 2,
        marginTop: 0.5,
        cursor: 'Pointer',
        color: 'white'
      }}
      onClick={handleRetryClick}
      component="a"
    >
      Retry
    </Box>
  );

  return (
    <SnackbarContent ref={ref} {...other}>
      <Alert
        severity={variant}
        variant="filled"
        icon={<Icon style={{ fill: 'white' }} />}
        sx={{
          minWidth: 354,
          backgroundColor,
          px: 2,
          py: 1,
          borderRadius: 2
        }}
        action={variant === 'error' && onClick && retry}
      >
        {message}
      </Alert>
    </SnackbarContent>
  );
};

export default React.forwardRef<HTMLDivElement, SnackbarProps>(Snackbar);
